import { render, staticRenderFns } from "./OrderFulfillmentStatus.vue?vue&type=template&id=99e82626&"
import script from "./OrderFulfillmentStatus.vue?vue&type=script&lang=js&"
export * from "./OrderFulfillmentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports